import React from "react";
import './CommonDialog.scss';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Box,
    Button,
    Avatar,
} from "@mui/material";

export interface CommonDialogProps {
    open: boolean;
    title: string;
    content?: React.ReactNode | string;
    confirmText?: string;
    cancelText?: string;
    onConfirm?: () => void;
    onClose: () => void;
    showActions?: boolean;
    showCancel?: boolean;             // 🆕 Cho phép ẩn/hiện nút Cancel
    disableEscapeKeyDown?: boolean;
    centerActions?: boolean;
    imageSrc?: string;
    imageAlt?: string;
    titleAlign?: "center" | "left";
    dialogClassName?: string;
    confirmButtonClassName?: string;
    cancelButtonClassName?: string;
}

const CommonDialog: React.FC<CommonDialogProps> = ({
    open,
    title,
    content,
    confirmText = "OK",
    cancelText = "Cancel",
    onConfirm,
    onClose,
    showActions = true,
    showCancel = true,
    disableEscapeKeyDown = false,
    centerActions = false,
    imageSrc,
    imageAlt = "guardian-avatar",
    titleAlign = "left",
    dialogClassName,
    confirmButtonClassName,
    cancelButtonClassName,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={dialogClassName}
            disableEscapeKeyDown={disableEscapeKeyDown}
        >
            {/* Tiêu đề Dialog */}
            <DialogTitle>
                <Box
                    display="flex"
                    alignItems="center"
                    gap={2}
                    justifyContent={titleAlign === "center" ? "center" : "flex-start"}
                >
                    {imageSrc && (
                        <Avatar
                            className="dialog-avatar"
                            src={imageSrc}
                            alt={imageAlt}
                            sx={{
                                width: 44,
                                height: 44,
                                borderRadius: "50%",
                                boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                            }}
                        />
                    )}
                    <Typography
                        variant="h6"
                        component="span"
                        sx={{
                            fontWeight: "bold",
                            // color: "text.primary",
                            color: "#414335",
                            fontSize: {lg:'1.2rem', md:"1.15rem", xs:"1.15rem"},
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
            </DialogTitle>

            {/* Nội dung */}
            <DialogContent sx={{ fontSize: "1.15rem" }}>
                {typeof content === "string" ? (
                    <Typography>{content}</Typography>
                ) : (
                    content
                )}

                {/* Nút hành động */}
                {showActions && (
                    <Box
                        mt={2}
                        display="flex"
                        justifyContent={centerActions ? "center" : "flex-end"}
                        gap={2}
                    >
                        {/* Chỉ render nút Cancel nếu showCancel = true */}
                        {showCancel && cancelText && (
                            <Button
                                onClick={onClose}
                                className={cancelButtonClassName}
                                sx={{
                                    textTransform: "none",
                                    fontSize: {lg:'1.15rem', md:"0.875rem"}
                                }}
                            >
                                {cancelText}
                            </Button>
                        )}

                        {onConfirm && (
                            <Button
                                variant="contained"
                                onClick={onConfirm}
                                className={confirmButtonClassName}
                                sx={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    fontSize: {lg:'1.15rem', md:"0.875rem"}
                                }}
                            >
                                {confirmText}
                            </Button>
                        )}
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default CommonDialog;
